import React, { useEffect, useState } from "react";
import * as echarts from "echarts";
import ReactEcharts from "echarts-for-react";
import world from "./world.json";
import { useLocation } from "react-router-dom";
import { t } from "../localization/localization";

const pointData = [];

const onEvents = {
  click: (params) => {
    const { seriesIndex, data } = params;
    if (seriesIndex === 0) return;
  },
};

const calculateMax = (arr) => {
  var max = 0;
  arr.forEach((element) => {
    let value = "";
    if (Array.isArray(element.value)) {
      value = parseInt(element.value[2]);
    }
    else {
      value = parseInt(element.value);
    }
    if (value > max) {
      max = value;
    }
  });
  return max;
};

const findTotalNumberOfElement = (arr) => {
  var total = 0;
  arr.forEach((element) => {
    try {
      total = total + Number(Array.isArray(element.value) ? element.value[2] : element.value);
    } catch (error) {
      console.log(
        "Error occured while converting ",
        element.value,
        " to number",
        error
      );
    }
  });
  return total;
};

export const WorldMap = ({ startDate, endDate, mapData, scattered }) => {
  const search = useLocation().search;
  const urlSearchParam = new URLSearchParams(search);
  const locale = urlSearchParam.get("locale");
  const [calculatedMaxValue, setCalculatedMaxValue] = useState(0);
  useEffect(() => {
    if (mapData && mapData.length > 0) {
      setCalculatedMaxValue(calculateMax(mapData));
    }
  }, [mapData]);
  const option = {
    title: {
      fontFamily: "Montserrat",
      subtextStyle: {
        fontSize: 14,
      },
      textStyle: {
        fontSize: 18,
      },
      bottom: "0%",
      text: `${t(locale, "/charts/handle/world-map")}`,
      subtext: `${startDate} - ${endDate} \n${t(locale, "/charts/handle/world-map/total-view")}:${findTotalNumberOfElement(
        mapData
      )} `,
    },
    tooltip: {
      padding: 5,
      backgroundColor: 'rgba(50,50,50,0.7)',
      borderColor: '#777',
      borderWidth: 1,
      textStyle : {
        color : "white"
      },
      opacity :0.4,
      trigger: "item",
      showDelay: 0,
      transitionDuration: 0.2,
    },
    geo: {
      map: "world",
      zoom: 1.3,
      roam: false,
      itemStyle: {
        color: "#eff0f1",
        borderColor: "#808080",
      },
    },
    series: [
      {
        name: "Count",
        type: scattered ? "effectScatter" : "map",
        geoIndex: 0,
        data: mapData,
        roam: "move",
        nodeClick: false,
        showEffectOn: "render",
        rippleEffect: {
          brushType: 'stroke'
        },
        coordinateSystem: "geo",
        encode: {
          value: 2,
        },
        itemStyle: {
          opacity: 0.7,
        },
        symbolSize: function (params) {
          return (Math.sqrt(params[2] / 60) + 0.05) * 50;
        },
      },
      {
        name: "bar",
        type: "effectScatter",
        animation: false,
        data: pointData,
        coordinateSystem: "geo",
        showEffectOn: "render",
        rippleEffect: {
          scale: 0,
          brushType: "fill",
        },
      },
    ],
    visualMap: {
      left: "right",
      min: 0,
      max: calculatedMaxValue,
      inRange: {
        color: [
          "#93BFCF",
          "#6096B4",
          "#CDE990",
          "#AACB73",
          "#FFF6C3",
          "#FFDB89",
          "#EF9A53",
          "#FF6E31",
          "#850000",
          "#DC0000",
        ],
      },
      text: ["High", "Low"],
      calculable: true,
    },
  };

  return (
    <>
      {echarts.registerMap("world", world)}
      <ReactEcharts
        style={{
          height: "500px",
          width: "80%",
          background: "#F4F4F4",
          borderRadius: "4px",
          border: "2px",
          padding: "4px",
          borderStyle: "solid",
        }}
        option={option}
        onEvents={onEvents}
      />
    </>
  );
};
